import { type AggRequest, fetchAgg } from '../../../../common/utils/fetch-agg';

import {
	mutateOperationName,
	operationName,
	quickFindMutateZeroQueriesMutation,
	quickFindZeroQueriesQuery,
} from './query';
import {
	type MutateZeroQueriesMutationType,
	type MutateZeroQueriesMutationVariables,
	type QuickFindZeroQueriesQueryType,
	type QuickFindZeroQueriesQueryVariables,
} from './types';

export type QuickFindZeroQueriesQueryProps = Pick<
	AggRequest<QuickFindZeroQueriesQueryVariables>,
	'aggAbsoluteUrl' | 'variables'
> & { headers: Record<string, string> };

export const zeroQueriesQuery = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindZeroQueriesQueryProps) => {
	return fetchAgg<QuickFindZeroQueriesQueryVariables, QuickFindZeroQueriesQueryType>({
		aggAbsoluteUrl,
		graphQuery: quickFindZeroQueriesQuery,
		variables,
		operationName,
		headers,
	});
};

export type QuickFindZeroQueriesMutationProps = Pick<
	AggRequest<MutateZeroQueriesMutationVariables>,
	'aggAbsoluteUrl' | 'variables'
> & { headers: Record<string, string> };

export const zeroQueriesMutation = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindZeroQueriesMutationProps) => {
	return fetchAgg<MutateZeroQueriesMutationVariables, MutateZeroQueriesMutationType>({
		aggAbsoluteUrl,
		graphQuery: quickFindMutateZeroQueriesMutation,
		variables,
		operationName: mutateOperationName,
		headers,
	});
};
